// removed by extract-text-webpack-plugin
module.exports = {"svg":"_1iWvmae6EzRXa50yal1PYN_0","progressCircularRotate":"_1Zv1Syrwc0slxbdxlEDfe_0","circle":"_2hKuQ_8kH2taOKkdlUrppQ_0","progressCircularDash":"_2Kpt6AzAmaLZ-bDUopykfl_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2617f985","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/common/BaseLoading.vue
// module id = vdpH
// module chunks = 4